import TemplateButton from '../../../../components/Template/Button'
import styled from '../../../../theme'

const Button = styled(TemplateButton as any)`
  display: block;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    display: inherit;
  }
`

export default Button
